import { DashboarSlots } from './types';
import { DashboardToolbar } from './dashboard-toolbar';
import { useDashboardContext } from './hooks/use-dashboard-context';
import { cn, memoClassNames } from '@/utils';

const classes = memoClassNames('Dashboard', ['root', 'toolbar', 'body']);

export type DashboardDisplayProps = Omit<
  React.ComponentProps<'div'>,
  'title'
> & {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  slots?: DashboarSlots;
  slotProps?: {
    body?: React.ComponentProps<'div'>;
  };
};

export function DashboardDisplay({
  className,
  title,
  subtitle,
  children,
  slots = {},
  slotProps,
  ...others
}: DashboardDisplayProps) {
  const { Toolbar = DashboardToolbar, Loading = null, Empty = null } = slots;
  const { loading, data } = useDashboardContext();

  if (loading && Loading) {
    return <Loading />;
  }

  if (!data && Empty) {
    return <Empty />;
  }

  const displayHeader = title || subtitle;

  return (
    <div
      {...others}
      className={cn(
        classes.root,
        'mm:relative mm:flex mm:flex-col mm:gap-2',
        className
      )}
    >
      {Toolbar ? (
        <Toolbar
          className={cn(classes.toolbar)}
          title={displayHeader || undefined}
        />
      ) : null}
      <div className={'mm:flex mm:flex-wrap mm:gap-2 mm:items-center'}>
        {children}
      </div>
    </div>
  );
}

DashboardDisplay.displayName = 'DashboardDisplay';
